<template>
    <div v-if="(isDispatcher || isAdmin || isMainCommercial || isCommercialDispatcher) &&
        req.status != 'Invalidado' &&
        req.status != 'Rechazado'
        ">
        <div>
            <card :id="id" :history="true" :exportXlsx="true" :title="'Solicitud de Muestra N° ' + id" bg="bg-dark text-white"
                icon="glass-martini" @exportRequest="exportRequest(id)" @showHistory="showHistory(id)">
                <template v-slot:titleBadge>
                    <management-countdown-badge :deadline="req.dispatchManagementDeadline" :sample-state="req.sampleState" />
                </template>
                <card class="card cardShadow-light" title="Datos Principales">
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th style="width: 20%">Unidad de Negocio:</th>
                                <td style="width: 30%">{{ req.businessUnitName }}</td>
                                <th style="width: 20%">Centro de Costo:</th>
                                <td style="width: 30%">
                                    <div v-if="req.sampleState < 6" class="row" style="margin: 0px !important">
                                        <div class="form-group col-md-10" style="padding: 0px !important">
                                            <v-select append-to-body :options="costCenters" :filterable="false" v-model="costCenter" @search="onSearch">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                        <div>
                                            <button class="btn btn-primary ml-4" title="Actualizar Fecha" type="button"
                                                @click="updateCostCenter">
                                                <i class="fas fa-save"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <span v-else="">{{ req.costCenterName }}</span>
                                </td>
                            </tr>
                            <tr>
                                <th style="width: 20%">Despacho Progresivo:</th>
                                <td style="width: 30%">{{ req.progressDispatch }}</td>
                                <th style="width: 20%">Objetivo de la Muestra:</th>
                                <td style="width: 30%">{{ req.sampleTargetName }}</td>
                            </tr>
                            <tr>
                                <th style="width: 20%">Detalles de objetivo:</th>
                                <td style="width: 30%">{{ req.sampleReasonName }}</td>                                
                                <th style="width: 20%">Fecha de Envío:</th>
                                <td style="width: 30%">{{ req.sendedAtString }}</td>
                            </tr>                            
                            <tr>
                                <th style="width: 20%">Fecha Requerida Despacho:</th>
                                <td style="width: 30%">{{ req.requiredDispatchDateString }}</td>
                                <th style="width: 20%">Fecha/Hora Límite de Gestión:</th>
                                <td style="width: 30%">
                                    <div v-if="(isAdmin || isOenology) && req.sampleState >= 1 && req.sampleState < 6" class="row" style="margin: 0px !important">
                                        <div class="form-group col-md-6" style="padding: 0px !important; margin-bottom: 0px;">
                                            <input v-model="managementDeadline" :min="sendedAtLocal" class="form-control" type="datetime-local" />
                                        </div>
                                        <div>
                                            <button class="btn btn-primary ml-4" title="Actualizar Fecha/Hora Límite" type="button" @click="updateDeadline">
                                                <i class="fas fa-save"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <template v-else>
                                        <span v-if="req.dispatchManagementDeadlineString">{{ req.dispatchManagementDeadlineString }}</span>
                                        <span v-else-if="req.sampleState !== 0" class="text-muted" title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">Pendiente de envío</span>
                                        <span v-else class="text-muted">Sin Registro</span>
                                    </template>
                                </td>
                            </tr>
                        </table>
                    </div>
                </card>
                <card class="card mt-2 cardShadow-light" title="Datos de despacho">
                    <div class="card border-secondary">
                        <div v-if="existDispatch" class="table-responsive">
                            <table class="table">
                                <tr>
                                    <th>Nombre de Empresa/Cliente:</th>
                                    <td>{{ dispatch.enterpriseName }}</td>
                                    <th>País</th>
                                    <td>{{ dispatch.country.name }}</td>
                                    <th>Ciudad:</th>
                                    <td>{{ dispatch.city.name }}</td>
                                </tr>
                                <tr>
                                    <th>Código Postal</th>
                                    <td>{{ dispatch.postalCode }}</td>
                                    <th>Dirección:</th>
                                    <td>{{ dispatch.address }}</td>
                                    <th>Segunda Dirección:</th>
                                    <td>{{ dispatch.secondAddress }}</td>
                                </tr>
                                <tr>
                                    <th>Teléfono:</th>
                                    <td>{{ dispatch.phoneNumber }}</td>
                                    <th>Email:</th>
                                    <td>{{ dispatch.email }}</td>
                                    <th>Contacto (Sr./Sra.):</th>
                                    <td>{{ dispatch.contactName }}</td>
                                </tr>
                                <tr>
                                    <th>Observaciones:</th>
                                    <td>{{ dispatch.remarks }}</td>
                                </tr>
                            </table>
                        </div>
                        <alert v-else message="Aún no se registra Despacho" />
                    </div>
                </card>
            </card>
            <modal id="showHistory" :lg="true" title="Historial de solicitud">
                <history-modal-request :historyOptions="historyOptions"></history-modal-request>
            </modal>
            <internal-dispatch :id="id" :component="component" @validComponent="reloadData" @saveRequireTransfer="reloadData" @updateObservations="reloadData" @saveOtherSemilaborate="reloadData" @saveDispatchComponent="reloadData" @saveOtherPt="reloadData" @getDetails="getDetails" :details="details" :minDate="minDate"
                :progressDispatch="req.progressDispatch" :request="req" />
        </div>
    </div>
</template>

<script>
import { Get, Put } from "../../../helper/axios.js";
import Card from "../../../components/Card.vue";
import HistoryModalRequest from "@/views/requests/history/HistoryModalRequest.vue";
import $ from "jquery";
import _ from "lodash";
import { base64ToArrayBuffer } from '@/helper/fileHelper.js';

export default {
    components: {
        HistoryModalRequest,
        Card,
    },
    data() {
        return {
            historyOptions: {
				id: null,
				history: [],
			},
            id: this.$route.params.id,
            apiUrl: this.$store.getters.apiUrl,
            isAdmin: this.$store.getters.isAdmin,
            isDispatcher: this.$store.getters.isDispatcher,
            isCommercial: this.$store.getters.isCommercial,
            isCourier: this.$store.getters.isCourier,
            isMainCommercial: this.$store.getters.isMainCommercial,
            isCommercialDispatcher: this.$store.getters.isCommercialDispatcher,
            isOenology: this.$store.getters.isOenology,
            Get,
            Put,
            managementDeadline: "",
            sendedAtLocal: "",
            req: {},
            existDispatch: false,
            details: [],
            component: [],
            minDate: "",
            costCenters: [],
            costCenter: {},
            businessUnitId: null
        };
    },
    created() {
        if (this.id) {
            this.index();
            this.getComponent();
            this.getDetails();       
        }
    },
    methods: {
        updateDeadline() {
            if (!this.managementDeadline) {
                window.toastr.warning("Debe ingresar la Fecha/Hora Límite de Gestión.");
                return;
            }
            if (this.sendedAtLocal && this.managementDeadline < this.sendedAtLocal) {
                window.toastr.warning("La Fecha/Hora Límite no puede ser anterior a la Fecha de Envío.");
                return;
            }
            this.$swal({
                title: "¿Desea Modificar la Fecha/Hora Límite de Gestión?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoading", true);
                    this.Put(
                        this.apiUrl + "v1/dispatchDateRequest/deadline/" + this.id,
                        { dispatchManagementDeadline: this.managementDeadline },
                        () => {
                            this.$store.commit("setLoading", false);
                            window.toastr.success("La Fecha/Hora Límite de Gestión ha sido Modificada correctamente.");
                            this.index();
                        }
                    );
                }
            });
        },
        index(){
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/requestsamples/" + this.id, (res) => {
                this.req = res.data;
                this.sendedAtLocal = res.data.sendedAt ? res.data.sendedAt.substring(0, 16) : "";
                this.managementDeadline = res.data.dispatchManagementDeadline ? res.data.dispatchManagementDeadline.substring(0, 16) : "";
                var createdAtRequest = new Date(
                    res.data.createdAt.split("-").reverse().join("-")
                );
                var dd = String(createdAtRequest.getDate() + 1).padStart(2, "0");
                var mm = String(createdAtRequest.getMonth() + 1).padStart(2, "0");
                var yyyy = createdAtRequest.getFullYear();
                this.minDate = yyyy + "-" + mm + "-" + dd;
                this.$store.commit("setLoading", false);
                this.businessUnitId = res.data.businessUnitId;
                this.costCenter = {
                    code: res.data.costCenterId,
                    label: res.data.costCenterName,
                }
                this.getCostCenters(res.data.businessUnitId);
            });
            this.$store.commit("setLoading", true);
            this.Get(
                this.apiUrl + "v1/dispatchs?sampleId=" + this.id,
                (res) => {
                    this.dispatch = res.data;
                    this.existDispatch = true;
                    this.$store.commit("setLoading", false);
                },
                () => {
                    this.existDispatch = false;
                }
            );
        },
        reloadData(){
            this.index();
            this.getDetails();
        },
        getDetails() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/requestsample/${this.id}/details`, (res) => {
                this.details = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        getComponent() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/selectedComponents/bySampleId/${this.id}`, (res) => {
                this.component = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        showHistory() {
			this.historyOptions.history = this.req.histories;
			$("#showHistory").modal("show");
		},
        getCostCenters(businessUnitId) {
            if (businessUnitId) {
                this.$store.commit("setLoading", true);
                this.Get(`${this.apiUrl}v1/businessunit/${businessUnitId}/costcenters`, (res) => {
                    this.costCenters = [];
                    res.data.forEach(item => { 
                        this.costCenters.push({
                            code: item.id,
                            label: `${item.name} (${item.description})`
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }
        },
        onSearch(search, loading) {
            if(search.length)
            {
                loading(true);
                this.search(loading, search, this)
            }
        },
        search: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&BusinessUnitId=" + vm.businessUnitId;
            vm.Get(vm.apiUrl + "v1/costCentersBusinessUnits?" + data, (res) => {
                vm.costCenters=[];
                res.data.forEach(item => { 
                    vm.costCenters.push({
                        code: item.id,
                        label: `${item.name} (${item.description})`
                    });
                });
            loading(false)
            });
        }, 500),
        updateCostCenter() {
			if (this.costCenter) {
				this.$swal({
					title: "¿Desea Modificar el Centro de Costo?",
					icon: "info",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
				}).then((result) => {
					if (result.value) {
						this.$store.commit("setLoading", true);
                        let data = {
                            id: this.id,
                            costCenterId: this.costCenter.code
                        }
						this.Put(this.apiUrl + "v1/RequestSamples/UpdateCostCenter", data, () => {
								this.$store.commit("setLoading", false);
                                window.toastr.success('Centro de Costo Actualizado Correctamente.');
                                this.index();
							}
						);
					}
				});
			} else
				window.toastr.warning("El Centro de Costo es Requerido");
		},
        exportRequest(id) {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/exportRequestSample/" + id, (res) => {
                var array = base64ToArrayBuffer(res.data);
                var a = window.document.createElement("a");
                a.href = window.URL.createObjectURL(
                    new Blob([array], {
                        type: "application/octet-stream",
                    })
                );
                a.download = "FCOM " + id + ".xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.$store.commit("setLoading", false);
            });
        },
    },
};
</script>
